// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const truncateAfterTwoDecimals = (x: number): number => Math.trunc(x * 100) / 100;
